import { LayoutDebitNote } from './Layout/LayoutDebitNote'
export const DebitNoteScreen = () => {
  return (
    <LayoutDebitNote />
  )
}
